"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STEP_MAPPER = void 0;
var InviteUserModal_1 = __importDefault(require("../InviteUserModal"));
var CreateCustomerModal_1 = __importDefault(require("../Modals/CreateCustomerModal"));
var FillInTheGaps_1 = __importDefault(require("./FillInTheGaps"));
var RequestFullOnboarding_1 = __importDefault(require("./instances/RequestFullOnboarding"));
exports.STEP_MAPPER = {
    SET_ACCOUNTING: {
        to: '/welcome',
        toWhenDone: '/welcome?wzStep=SET_ACCOUNTING',
        stepOwner: 'company',
        label: 'Connect your accounting system',
    },
    WELCOME_STEP: {
        to: '/welcome',
        stepOwner: 'user',
        label: 'Welcome steps',
    },
    FILL_IN_THE_GAPS: {
        StepComponent: FillInTheGaps_1.default,
        stepOwner: 'company',
    },
    TEAMS_CREATION: {
        to: '/team-creation',
        stepOwner: 'company',
        label: 'Create teams',
    },
    INVITE_TEAMMATES: {
        stepOwner: 'user',
        label: 'Invite colleagues',
        ModalComponent: InviteUserModal_1.default,
    },
    // REVIEW_RECOMMENDATIONS: {
    //   to: '/recommendations',
    //   stepOwner: 'user',
    //   disabledCondition: (company) => !company?.serviceStatsCount,
    //   label: 'Review saving opportunities',
    //   addStepOnClick: true,
    // },
    REQUEST_SAAS_AUDIT: {
        to: '/saas-audit',
        stepOwner: 'company',
        label: 'Request SaaS Audit',
        addStepOnClick: true,
    },
    VISIT_DEALS: {
        to: '/deals',
        stepOwner: 'user',
        label: 'Check out Hudled deals',
        addStepOnClick: true,
    },
    FIRST_CUSTOMER_CONNECTED: {
        ModalComponent: CreateCustomerModal_1.default,
        label: 'Access your first customer',
        stepOwner: 'user',
    },
    ANSWER_FULL_ONBOARDING: {
        StepComponent: RequestFullOnboarding_1.default,
        stepOwner: 'user',
    },
};
